import React, { Fragment } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { SignPad } from "Docs/Components";
import { ELLENSBURG_WA_READ_DOCUMENT_HREF } from "./constants";

export default function StateTaxEllensburgView({
  form,
  errors,
  uiConfig,
  sign,
  onFormChange,
  onDateChange,
  onSignature,
  setSignContainer,
  onReadDocumentClick,
}) {
  const readHref =
    uiConfig.readDocumentHref || ELLENSBURG_WA_READ_DOCUMENT_HREF;
  const readLinkLabel = uiConfig.readDocumentLinkText || "Read document";

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="row form-row">
          <div className="col">
            <div className="imp__notes_handbook">
              <div>
                Please click the link below to read and review the Washington
                state withholding information. Once you have read and
                understood, please sign the acknowledgment below.
              </div>
              <div className="handbook_read_text">
                <a
                  href={readHref}
                  onClick={() => onReadDocumentClick?.()}
                  target="_blank"
                  rel="noreferrer"
                >
                  {readLinkLabel}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="row form-row no_border">
          <div className="col">
            <div className="inputs-col">
              <div className="inputs-head">
                Printed Name<span className="required-star">&#x2A;</span>
              </div>
              <div className="inputs-items">
                <input
                  type="text"
                  className={`${errors["form.employee_printed_name"] ? "error" : ""}`}
                  name="employee_printed_name"
                  id="employee_printed_name_ellensburg"
                  value={form.employee_printed_name || ""}
                  field="form.employee_printed_name"
                  placeholder="- Enter here -"
                  required
                />
                {errors["form.employee_printed_name"] && (
                  <label
                    htmlFor="employee_printed_name_ellensburg"
                    className="error_label"
                  >
                    {errors["form.employee_printed_name"]}
                  </label>
                )}
              </div>
            </div>
            <div className="inputs-col">
              <div className="inputs-head">
                Date<span className="required-star">&#x2A;</span>
              </div>
              <div className="inputs-items">
                <DatePicker
                  className={`${errors["form.signed_date"] ? "error" : ""} w-100`}
                  name="signed_date"
                  id="signed_date_ellensburg"
                  selected={moment(form.signed_date)}
                  field="form.signed_date"
                  placeholder="mm/dd/yyyy"
                  onChange={(date) => onDateChange("form.signed_date", date)}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  autoComplete="off"
                  required
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row form-row">
          <div className="col w-50">
            <div className="inputs-col">
              <div className="inputs-head">
                Employee Signature
                <span className="required-star">&#x2A;</span>
              </div>
              <div className="inputs-items">
                <div ref={setSignContainer} className="sign_here">
                  {sign && (
                    <Fragment>
                      <SignPad
                        id="stateTaxEllensburgSignPad"
                        height={144}
                        width={sign.width || 446}
                        handleSignature={onSignature}
                        signature={form.employee_signature}
                      />
                      <input
                        type="hidden"
                        value={form.employee_signature || ""}
                        name="employee_signature"
                        field="form.employee_signature"
                        required
                      />
                      {errors["form.employee_signature"] && (
                        <label
                          htmlFor="employee_signature"
                          className="error_label"
                        >
                          {errors["form.employee_signature"]}
                        </label>
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row form-row last">
          <div className="col">
            <div className="inputs-col">
              <div className="check_radio_group check_disclaimer">
                <div className="check_radio_item">
                  <input
                    type="checkbox"
                    name="disclaimer_check"
                    id="disclaimer_check_ellensburg"
                    field="form.disclaimer_check"
                    checked={!!form.disclaimer_check}
                    onChange={onFormChange}
                    required
                  />
                  <span className="checkbox_checkbox" />
                  <label htmlFor="disclaimer_check_ellensburg">
                    I have confirmed the above details are true and valid.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
